import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrosoft = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#ff5722",
			d: "M22 22H6V6h16z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#4caf50",
			d: "M42 22H26V6h16z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ffc107",
			d: "M42 42H26V26h16z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#03a9f4",
			d: "M22 42H6V26h16z"
		})
	]
});
export default SvgMicrosoft;
